import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from '../../store/actions';

// Layout Related Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Rightbar from '../CommonForBoth/Rightbar';

const Layout = ({
  children,
  isPreloader,
  leftSideBarTheme,
  layoutWidth,
  leftSideBarType,
  topbarTheme,
  showRightSidebar,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
}) => {
  const [isMobile] = useState(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
  const location = useLocation();

  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    // Preloader
    if (isPreloader) {
      const preloader = document.getElementById('preloader');
      const status = document.getElementById('status');
      if (preloader && status) {
        preloader.style.display = 'block';
        status.style.display = 'block';
        setTimeout(() => {
          preloader.style.display = 'none';
          status.style.display = 'none';
        }, 2500);
      }
    } else {
      const preloader = document.getElementById('preloader');
      const status = document.getElementById('status');
      if (preloader && status) {
        preloader.style.display = 'none';
        status.style.display = 'none';
      }
    }

    // Scroll Top to 0
    window.scrollTo(0, 0);

    // Page title
    const currentage = capitalizeFirstLetter(location.pathname);
    document.title = `${currentage} | Brother TECNET | IPM Dealer Service Platform`;

    // Apply settings from Redux
    if (leftSideBarTheme) changeSidebarTheme(leftSideBarTheme);
    if (layoutWidth) changeLayoutWidth(layoutWidth);
    if (leftSideBarType) changeSidebarType(leftSideBarType);
    if (topbarTheme) changeTopbarTheme(topbarTheme);
  }, [
    isPreloader,
    leftSideBarTheme,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    changeSidebarTheme,
    changeSidebarType,
    changeTopbarTheme,
    changeLayoutWidth,
    location.pathname,
  ]);

  const toggleMenuCallback = () => {
    if (leftSideBarType === 'default') {
      changeSidebarType('condensed', isMobile);
    } else if (leftSideBarType === 'condensed') {
      changeSidebarType('default', isMobile);
    }
  };

  return (
    <>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar theme={leftSideBarTheme} type={leftSideBarType} isMobile={isMobile} />
        <div className="main-content">{children}</div>
        <Footer />
      </div>
      {showRightSidebar && <Rightbar />}
    </>
  );
};

const mapStatetoProps = (state) => ({
  ...state.Layout,
});

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(Layout);
